var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconOutpostStrokeLg = function SvgIconOutpostStrokeLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M24 9v32"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17,
    r: 10,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 17,
    r: 10,
    stroke: props.color,
    strokeWidth: 2
  }));
};
export default SvgIconOutpostStrokeLg;